import React, { FC, useEffect, useState } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
// Data
import { local } from 'data/lib/local-json'
import userGroupService from "data/user-groups"
import validationService from "data/validate"
// Components, Icons
import { AddIcon } from "images/icons/tools"
import { Errors } from "components/asset-management/errors"
import { Toolbar } from "components/subnav"
import UserGroupTable from "components/user-admin/user-group-table"
// Styles
import { UserGroups_s } from "components/user-admin/user-styles"

const UserGroups: FC<RouteComponentProps> = (props) => {
  const [userGroupsData, setData] = useState<object[]>([])
  const [_errors, setErrors] = useState<any>()
  const tableId = "user-groups-table"
  const profile = local("auth.profile")
  const id      = profile.organizationId;

  useEffect(() => {
    const filter = (errors):object => {
      return {
        ...errors,
        errordetail: _.pick(errors.errordetail, 'usergroup'),
        calcDetail: undefined
      }
    }
    const validationSubscription = validationService.stream().subscribe((e) => {
      setErrors(e)
    })
    validationService.addFilter(filter)
    validationService.validate('usergroup')

    return () => {
      validationSubscription.unsubscribe()
      validationService.removeFilter(filter)
    }
  },[])

  useEffect(() => {
    const userGroupSubscription = userGroupService.stream().subscribe(data => {
      setData(data.groups);
    })

    return function cleanup() {
      userGroupSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    userGroupService.fetchUserGroups()
  }, [id])
  
  const Add = () => {
    return (
      <a onClick={() => userGroupService.create()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <UserGroups_s>
      <Toolbar>
        <Add />
        <Errors />
      </Toolbar>
      { userGroupsData && <UserGroupTable tableId={tableId} data={userGroupsData} /> }
    </UserGroups_s>
  )
}

export default UserGroups
